import en_US from './json/en_US.json'; // 英语
import zh_CN from './json/zh_CN.json'; // 简体中文
import zh_HK from './json/zh_HK.json'; // 繁体中文（中国香港）
import zh_TW from './json/zh_TW.json'; // 繁体中文（中国台湾）
import vi from './json/vi.json'; // 越南语
import es from './json/es.json'; // 西班牙语
import fr from './json/fr.json'; // 法语
import nl from './json/nl.json'; // 荷兰语
import pt from './json/pt.json'; // 葡萄牙语
import th from './json/th.json'; // 泰语
import de from './json/de.json'; // 德语
import it from './json/it.json'; // 意大利语
import ja from './json/ja.json'; // 日语
import ko from './json/ko.json'; // 韩语
import ru from './json/ru.json'; // 俄语
import pl from './json/pl.json'; // 波兰语
import da from './json/da.json'; // 丹麦语
import uk from './json/uk.json'; // 乌克兰语
import tr from './json/tr.json'; // 土耳其语
import ro from './json/ro.json'; // 罗马尼亚语
import ar from './json/ar.json'; // 阿拉伯语
import cs from './json/cs.json'; // 捷克语
import id from './json/id.json'; // 印尼语
import he from './json/he.json'; // 希伯来语
import hu from './json/hu.json'; // 匈牙利语
import ka from './json/ka.json'; // 格鲁吉亚语
import sr from './json/sr.json'; // 塞尔维亚语
import kk from './json/kk.json'; // 哈萨克语
import ms from './json/ms.json'; // 马来语
import el from './json/el.json'; // 希腊语
import mk from './json/mk.json'; // 马其顿语
import sv from './json/sv.json'; // 瑞典语
import sl from './json/sl.json'; // 斯洛文尼亚语
import hr from './json/hr.json'; // 克罗地亚语
import sk from './json/sk.json'; // 斯洛伐克语

export default {
    en_US,
    zh_CN,
    zh_HK,
    zh_TW,
    vi,
    es,
    fr,
    nl,
    pt,
    th,
    de,
    it,
    ja,
    ko,
    ru,
    pl,
    da,
    uk,
    tr,
    ro,
    ar,
    cs,
    id,
    he,
    hu,
    ka,
    sr,
    kk,
    ms,
    el,
    mk,
    sv,
    sl,
    hr,
    sk
};
